<template>
  <div class="mk-load">
    <div class="mk-load__container">
      <span class="mk-load__title">
        {{$t('load.title')}}
      </span>
      <div class="mk-load__privacy" :class="privacyError?'mk-load__privacy--error':''">
        <input type="checkbox" id="privacy" name="privacy" v-model="privacyPolicyAccepted">
        <label for="privacy">
          {{$t('start.accept')}}
          <a href="https://mk-solutions.com/en/privacy-policy/">
            {{$t('start.privacy')}}
          </a>
        </label>
      </div>
      <button
        class="mk-load__secondary"
        @click="closeCallback"
      >
        {{$t('load.cancel')}}
      </button>
      <button
        class="mk-load__primary"
        @click="submit"
      >
        {{$t('load.load')}}
      </button>
    </div>
  </div>
</template>

<script>
/**
 * Load Saved Popup
 * @author David <david.prenninger@gmx.de>
 *
 * This component shows a modal asking the user to load the last configuration.
 * As this is a new entry point to the application the user has to agree to the privacy policies.
 */
export default {
  props: {
    closeCallback: Function,
    loadCallback: Function,
  },
  data() {
    return {
      privacyPolicyAccepted: false,
      privacyError: false,
    };
  },
  methods: {
    submit() {
      if (this.privacyPolicyAccepted) {
        this.loadCallback();
        return;
      }
      this.privacyError = true;
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/assets/style/defaults.scss";

.mk-load {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($c_primary, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;

  &__title {
    font-size: 20px;
  }

  &__container {
    background-color: $c_white;
    padding: 10px;
    box-shadow: $bs_md;
    border-radius: $br_md;
    color: $c_primary;
  }

  &__privacy {
    padding: 20px 10px;
    transition: all 0.5s ease-in;
    margin: 5px 0;

    a {
      color: $c_primary;

      &:not(.btn-text-skin):hover{
        color: $c_primary;
      }
    }

    &--error {
      color: $c_white;
      background-color: $c_accent;
      border-radius: $br_md;
      box-shadow: $bs_md;

      a {
        color: $c_white;
        &:not(.btn-text-skin):hover {
          color: $c_white;
        }
      }
    }
  }

  &__secondary {
    background-color: $c_white;
    margin: 5px 10px;
    color: $c_accent;
    padding: 10px 20px;
    border-radius: $br_md;
    box-shadow: $bs_md;
    border: none;
    width: fit-content;
  }

  &__primary {
    margin: 5px 10px;
    background-color: $c_accent;
    color: $c_white;
    padding: 10px 20px;
    border-radius: $br_md;
    box-shadow: $bs_md;
    border: none;
    width: fit-content;
  }
}
</style>
